import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Checkbox, {
  CheckboxProps,
} from '@/components/molecules/checkbox/checkbox';
import styles from './filter-slide-in-single-checkbox.module.scss';

interface FilterSlideInSingleCheckboxProps {
  /** Additional class name */
  className?: string;
  /** The icon to render */
  icon?: IconName;
  /** Whether the checkbox is highlighted */
  isHighlighted?: boolean;
  /** The option to show */
  option?: CheckboxProps;
}

const FilterSlideInSingleCheckbox = ({
  className,
  icon,
  isHighlighted = false,
  option,
}: FilterSlideInSingleCheckboxProps) => {
  return (
    <div
      className={classNames(styles.component, className, {
        [styles.isHighlighted]: isHighlighted,
      })}
    >
      <Checkbox {...option} className={styles.singleCheckBox} />

      {icon && <Icon name={icon} size={20} />}
    </div>
  );
};

FilterSlideInSingleCheckbox.displayName = 'FilterSlideInSingleCheckbox';

export default FilterSlideInSingleCheckbox;
